import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { AppState } from '../../../../../../app.service';
import { Service } from '../../../direct-connect.service';
import {TranslateService} from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../../common/global-variables';
let $ = require('jquery');
import { VcaAlertsService } from '../../../../../../../common/vca-alerts/vca-alerts.service';

@Component({
  selector: 'select-gateway',
  styles: [require('../../../direct-connect.scss')],
  template: require('./select-gateway.html'),
    providers: [
    Service,  TranslateService
  ]
})

export class SelectGateway {
    @Input() isWizardOpen: boolean = false;
    @Input() stepId: number;
    @Input() showBusy: boolean = false;
    @Input() createData: any;
    @Output() stepEventEmitter: EventEmitter<any> = new EventEmitter();

    private isVDCLoading: boolean = false;
    private isEdgeLoading: boolean = false;
    private selectedOrgVdc: any;
    private selectedEdge: any ;
    private tableData: any = [];
    private subscribeHandler;
    private isTranslationready: boolean = true;
    private arrOrgVdc: Array<any> = [];
    private arrEdge: Array<any> = [];
    private vdcOption = {
        name: 'Select a VDC',
        id: -1
    };

    private edgeOption = {
        name: 'Select a Gateway',
        id: -1
    };

    private dataModel = {
        orgVDC: {name:'', id:''},
        edge: {name:'', id:''},
        directConnectName: '',
        isStepValid: false,
        stepId: -1
    };

    constructor(public appState: AppState,
        public service: Service,
        private translate: TranslateService,
        private alert: VcaAlertsService) {
        translate.use(GlobalVariables.LOCALE);
    }

    ngOnInit() {
    }

    ngOnChanges(changes) {
        if (this.stepId >= 0) {
            this.dataModel.stepId = this.stepId;
        }
        if (this.isWizardOpen) {
            this.initializeStep();
        }
    }

    initializeStep() {
        this.arrOrgVdc = [];
        this.arrEdge = [];
        this.dataModel.orgVDC.id = '';
        this.dataModel.orgVDC.name = '';
        this.dataModel.edge.id = '';
        this.dataModel.edge.name = '';
        if (this.createData && this.createData.directConnectConfiguration) {
            this.dataModel.directConnectName = this.createData.directConnectConfiguration.name;
            this.getOrgVDCs(this.dataModel.directConnectName);
        }
        this.emitData();
    }

    getOrgVDCs(directConnectName: string) {
        this.isVDCLoading = true;
        if (!directConnectName || directConnectName === '') {
            return;
        }
        this.subscribeHandler = this.service.getOrgVDCs(directConnectName)
        .subscribe(
        (tableData: any) => {
            // This can be removed once fixed in backend
            let result = [];
            let name: string = '';
            for (let i = 0; i < tableData.length; i++) {
                name = (tableData[i].vcd && tableData[i].vcd.name) ? tableData[i].vcd.name : '';
                if (name && name.toLocaleLowerCase() !== 'vmware_service') {
                    result.push (tableData[i]);
                }
            }
            this.arrOrgVdc = result;
            this.isVDCLoading = false;
        },
        error => {
            this.service.logError(error, 'getOrgVDCs() Error');
            this.alert.danger(['Failed to get OrgVDCs', error], 'select-gateway');
            this.isVDCLoading = false;
        },
        () => this.service.logOperationCompleted('getOrgVDCs() Completed')
        );
    }

    getEdges(vdcId: string) {
        this.isEdgeLoading = true;
        this.subscribeHandler = this.service.getEdges(vdcId)
        .subscribe(
        (tableData: any) => {
            this.arrEdge = tableData;
            this.isEdgeLoading = false;
        },
        error => {
            this.service.logError(error, 'getEdges() error');
            this.alert.danger(['Failed to get Edges', error], 'select-gateway');
            this.isEdgeLoading = false;
        },
        () => this.service.logOperationCompleted('getEdges() Completed')
        );
    }

    selectOrgVdcsChange(event) {
        if (event.id === -1) {
            this.dataModel.orgVDC.id = '';
            this.dataModel.orgVDC.name = '';
            this.arrEdge = [];
            this.emitData();
            return;
        }
        this.dataModel.orgVDC.id = event.id;
        this.dataModel.orgVDC.name = event.name;
        this.getEdges(event.id);
    }

    selectEdgeGWChange(event) {
        if (event.id === -1) {
            this.dataModel.edge.id = '';
            this.dataModel.edge.name = '';
            this.emitData();
            return;
        }
        this.dataModel.edge.id = event.id;
        this.dataModel.edge.name = event.name;
        this.emitData();
    }

    emitData() {
        this.dataModel.isStepValid = (this.dataModel.orgVDC.id !== '' && this.dataModel.edge.id !== '') ? true : false;
        this.stepEventEmitter.emit(this.dataModel);
    }

    getSelectVDCText() {
        return this.translate.instant('directConnect.wizard.selectVDC');
    }

    getSelectGatewayText() {
        return this.translate.instant('directConnect.wizard.selectAGateway');
    }

}



// WEBPACK FOOTER //
// ./src/app/components/network/direct-connect/wizards/connect-gateway/steps/select-gateway.component.ts